import React from 'react'
import styled, { css } from 'styled-components'
import { useDispatch } from 'react-redux'
import { InfoItem } from 'components'
import Icon from 'components/Icon'
import ConfirmModal from 'components/ConfirmModal'
import { MovieType } from 'generated/graphql'
import NoImage from 'assets/no-image.jpg'
import { useDeleteItem } from 'hooks'
import { _, colors } from 'utils'
import { addModal } from 'features/modals/modalSlice'
import TagsIndicator from 'components/lists/TagsIndicator'
import UpdateMovie from './UpdateMovie'
import { deleteMovie, updateMoviePublished } from '../graphql/mutation'

const S = {
    InfoItem: styled(InfoItem)<{ isOpen: boolean }>`
        margin-left: -27px;
        padding-left: 27px;
        & .info-wrapper {
            padding-right: 80px;
        }
        & .info-actions > span {
            opacity: 0;
        }
        &:hover .info-actions > span {
            opacity: 1;
        }
        ${({ isOpen }) => !isOpen && css`
            background-color: #F9FAFA!important;
            & > * {
                opacity: 0.5;
            }
            & > .info-actions span:last-child {
                opacity: 1;
            }
        `}
    `
}

const MovieRow = ({ movie, callGetMovies }: { movie: MovieType, callGetMovies: () => void }) => {
    const dispatch = useDispatch()
    const deleteFn = (id) => deleteMovie({ id })
    const { showDeleteConfirmModal } = useDeleteItem(deleteFn, callGetMovies)
    const isOpen = movie.published

    const showUpdateModal = () => {
        dispatch(addModal({
            Component: ({ close }: { close: () => void }) => (
                <UpdateMovie
                    close={close}
                    callGetMovies={callGetMovies}
                    movie={movie}
                />
            ),
            header: _('cinema.update_movie.modal_header'),
        }))
    }

    const updatePublished = () => {
        updateMoviePublished(movie.id, !isOpen)
        callGetMovies()
    }

    const showConfirmModal = () => {
        dispatch(addModal({
            Component: ({ close }: { close: () => void }) => (
                <ConfirmModal
                    close={close}
                    title={
                        isOpen
                            ? _('movie.form.close_movie_title_modal')
                            : _('movie.form.open_movie_title_modal')
                    }
                    confirmDescription={
                        isOpen
                            ? _('movie.form.close_movie_description_modal')
                            : _('movie.form.open_movie_description_modal')
                    }
                    variantConfirm="primary"
                    onConfirm={updatePublished}
                />
            ),
            shouldNotWrap: true
        }))
    }

    return (
        <S.InfoItem
            image={movie.imageThumbnail || NoImage}
            name={movie.title}
            description={movie.subtitle}
            isBoldName={false}
            squareImage
            isOpen={isOpen}
            onClick={showUpdateModal}
            renderTagsIndicator={() => <TagsIndicator row={movie} />}
        >
            <Icon icon="edit" size={18} onClick={showUpdateModal} />
            <Icon icon="trash" size={18} onClick={() => showDeleteConfirmModal(movie.id)} />
            <Icon
                icon={isOpen ? 'view' : 'viewOff'}
                color={isOpen ? colors.primary : colors.icon}
                size={18}
                onClick={showConfirmModal}
            />
        </S.InfoItem>
    )
}

export default MovieRow
